module.exports = __webpack_public_path__ + "img/friendbuy-landing-banner.3a4d7767.png";